import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import FloatingQuizCTA from "@/components/FloatingQuizCTA";
import Home from "@/pages/Home";
import Breeds from "@/pages/Breeds";
import BreedProfile from "@/pages/BreedProfile";
import Knowledge from "@/pages/Knowledge";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Quiz from "@/pages/Quiz";
import Maintenance from "@/pages/Maintenance";
import NotFound from "@/pages/NotFound";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";

// Site-wide maintenance mode. Controlled by REACT_APP_MAINTENANCE_MODE in /app/frontend/.env
// Set to "false" and redeploy to bring the full site back online.
const MAINTENANCE_MODE =
    (process.env.REACT_APP_MAINTENANCE_MODE || "").toLowerCase() === "true";

function App() {
    if (MAINTENANCE_MODE) {
        return (
            <LanguageProvider>
                <div className="App font-sans">
                    <Maintenance />
                    <Toaster position="bottom-right" />
                </div>
            </LanguageProvider>
        );
    }

    return (
        <LanguageProvider>
            <div className="App font-sans">
                <BrowserRouter>
                    <ScrollToTop />
                    <Navigation />
                    <main>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/breeds" element={<Breeds />} />
                            <Route path="/breeds/:slug" element={<BreedProfile />} />
                            <Route path="/knowledge" element={<Knowledge />} />
                            <Route path="/gallery" element={<Gallery />} />
                            <Route path="/quiz" element={<Quiz />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </main>
                    <FloatingQuizCTA />
                    <Footer />
                    <Toaster position="bottom-right" />
                </BrowserRouter>
            </div>
        </LanguageProvider>
    );
}

export default App;
